<template>
  <div>
    <el-row :gutter="24">
      <el-form :model="form" label-width="80px">
        <el-col :span="24" class="mb-16">
          <el-card>
            <el-form-item :label="$t('watermark::页面水印')" style="margin-bottom: 0">
              <el-switch v-model="form.status" :active-value="1" :inactive-value="0"></el-switch>
            </el-form-item>
          </el-card>
        </el-col>
        <div v-if="form.status">
          <el-col :span="14">
            <!-- <el-form-item label="覆盖页面">
              <el-checkbox-group v-model="form.pages">
                <el-checkbox label="报表中心" name="1"></el-checkbox>
                <el-checkbox label="个人报表" name="2"></el-checkbox>
                <el-checkbox label="看板管理" name="3"></el-checkbox>
                <el-checkbox label="系统设置" name="4"></el-checkbox>
              </el-checkbox-group>
            </el-form-item> -->
            <el-card>
              <p class="watermark-title">{{ $t('watermark::水印设计') }}</p>
              <el-form-item :label="$t('watermark::水印名称')">
                <!-- 防止使用了当前用户名作为水印名称，而修改了默认的水印名称 -->
                <el-input :value="$store.state.user.userName" :disabled="form.userName" v-if="form.userName"></el-input>
                <el-input v-model="form.text" :disabled="form.userName" v-else></el-input>
                <el-checkbox v-model="form.userName" @change="changeName">
                  <span style="color: #999999">{{ $t('watermark::use-userName') }}</span>
                </el-checkbox>
              </el-form-item>
              <el-form-item :label="$t('watermark::字号')">
                <el-select v-model="form.fontSize">
                  <el-option :label="num + 11" :value="num + 11" v-for="num in 89" :key="num"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('watermark::颜色')">
                <el-color-picker v-model="form.color"></el-color-picker>
              </el-form-item>
              <el-form-item :label="$t('watermark::透明度')" style="margin-bottom: 0">
                <el-slider :min="10" v-model="form.opacity" style="display: inline-block; width: 85%"></el-slider>
                <span class="opacity">{{ form.opacity }}%</span>
              </el-form-item>
            </el-card>
            <!-- <el-form-item label="尺寸（宽*高)">
              <el-input v-model="form.text"></el-input>
            </el-form-item> -->
          </el-col>
          <el-col :span="10">
            <el-card>
              <p class="watermark-title">{{ $t('watermark::水印预览') }}</p>
              <div class="preview" id="previewShowWrap"></div>
            </el-card>
          </el-col>
        </div>
      </el-form>
    </el-row>
    <footer-fixed>
      <el-button type="primary" @click="submit" :loading="loading">{{ $t('watermark::保存') }}</el-button>
    </footer-fixed>
  </div>
</template>

<script>
import WaterMark from '@/utils/waterMark'
import { postWatermark } from '@/server/user'
export default {
  data() {
    return {
      form: {},
      waterMark: null,
      loading: false,
    }
  },
  activated() {
    this.form = this.$deepClone(this.newForm)
  },
  mounted() {
    if (this.newForm.status) {
      this.initWatermark()
    }
  },
  methods: {
    changeName(val) {
      if (val) {
        this.form.text = this.$store.state.user.userName
      } else {
        // 如果不是使用当前用户名作为水印，则回退成之前的水印名称
        this.form.text = this.$store.state.user.watermark.text
      }
    },
    initWatermark() {
      this.$nextTick(() => {
        this.waterMark = new WaterMark(document.getElementById('previewShowWrap'), this.form)
      })
    },
    async submit() {
      this.loading = true
      const { data } = await postWatermark({
        status: this.form.status,
        value: JSON.stringify(this.form),
      })
      this.loading = false
      if (data.code === this.$code) {
        this.$message.success('保存成功')
        this.$store.commit('user.watermark', this.form)
      }
    },
  },
  computed: {
    newForm() {
      return this.$store.state.user.watermark
    },
  },
  watch: {
    newForm: {
      handler(val) {
        this.form = this.$deepClone(val)
      },
      deep: true,
    },
    form: {
      handler(val) {
        if (!!val.status) {
          if (this.waterMark) {
            this.waterMark.refresh(val)
          } else {
            this.initWatermark()
          }
        } else {
          this.waterMark = null
        }
      },
      deep: true,
    },
  },
}
</script>

<style scoped lang="scss">
.watermark-title {
  width: 80px;
  text-align: right;
  font-weight: bold;
  color: #010517;
  font-size: 14px;
  padding-right: 12px;
  margin-bottom: 24px;
  box-sizing: border-box;
}
.opacity {
  margin-left: 16px;
  line-height: 38px;
  display: inline-block;
  vertical-align: top;
}
.preview {
  position: relative;
  height: 292px;
  border: 1px solid #e8e8e8;
}
</style>
